export enum BillOfMaterialsTemplateFlowStatus {
  Approved = "approved",
  Rejected = "rejected",
  Internal = "internal",
}
